/* Copyright 2020 Thermopylae Sciences + Technology. All Rights Reserved. v202205311200 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* TODO3: Cost calculator page */
/* TODO4: Documentation note: Best to use type ‘address’ + location/radius for store checkout */
/* TODO4: Documentation note: Best to use type 'geocode' standard for other uses */
/* TODO4: Documentation note: Take opportunity to use device / browser location; possibly integrate some such functionality? */
/* TODO4: Add dual-input option for session re-use */
/* TODO3: Fall back to geocode of string if Place ID doesn't work */
/* TODO4: Build typings file and create instructions for including */
/* TODO: Publish as private NPM module? */
/* TODO: Document place result types */
var tsciences;
(function (tsciences) {
    function defaultAutocompleteOptions() {
        return {
            billingStrategy: 'session-geocode',
            letterBuffer: 2,
            timeBufferMilliseconds: 0,
            type: 'geocode',
            location: null,
            countries: null,
            selectionFillFormat: 'full-description'
        };
    }
    var BASIC_PLACE_DETAILS_FIELDS = [
        'address_component',
        'adr_address',
        'business_status',
        'formatted_address',
        'geometry',
        'icon',
        'name',
        'photo',
        'place_id',
        'plus_code',
        'type',
        'url',
        'utc_offset_minutes',
        'vicinity'
    ];
    var SpartanAutocomplete = /** @class */ (function () {
        function SpartanAutocomplete(inputElement, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            this.token = null;
            this.tokenInUse = false;
            this.timeout = null;
            this.focused = false;
            this.placeId = null;
            this.predictionSelectedListener = null;
            this.warnForMissingOptions(options);
            this.predictionsElement = document.createElement('ul');
            this.styleListElement(this.predictionsElement);
            if (!inputElement || inputElement.tagName !== 'INPUT') {
                throw new Error(SpartanAutocomplete.ELEMENT_INVALID_ERROR);
            }
            this.inputElement = inputElement;
            this.inputElement.onkeyup = function (event) {
                _this.onInput(event);
            };
            this.inputElement.onblur = function () {
                _this.onBlur();
            };
            this.options = Object.assign(defaultAutocompleteOptions(), options);
            this.validateOptions(this.options);
            this.autocompleteService = new google.maps.places.AutocompleteService();
            this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
            this.geocoder = new google.maps.Geocoder();
            this.token = new google.maps.places.AutocompleteSessionToken();
            this.tokenInUse = this.options.billingStrategy === 'session-only';
        }
        SpartanAutocomplete.prototype.setLocation = function (location) {
            this.options.location = location;
        };
        SpartanAutocomplete.prototype.fillAddress = function (location) {
            var _this = this;
            if (typeof location === 'string') {
                this.fillInputValue(location);
                return Promise.resolve(location);
            }
            else {
                return new Promise(function (resolve, reject) {
                    _this.geocoder.geocode({ location: location }, function (results) {
                        if (results && results.length > 0) {
                            var closestResult = results[0];
                            var address = closestResult.formatted_address;
                            if (_this.options.selectionFillFormat === 'main-text') {
                                address = address.split(",")[0];
                            }
                            _this.fillInputValue(address, closestResult.place_id);
                            resolve(address);
                        }
                        else {
                            reject(new Error(SpartanAutocomplete.NO_GEOCODE_RESULTS_ERROR));
                        }
                    });
                });
            }
        };
        SpartanAutocomplete.prototype.fillInputValue = function (value, placeId) {
            this.placeId = placeId || null;
            this.inputElement.value = value;
            this.removePredictions();
        };
        SpartanAutocomplete.prototype.onPredictionSelected = function (listener) {
            this.predictionSelectedListener = listener;
        };
        SpartanAutocomplete.prototype.warnForMissingOptions = function (options) {
            if (typeof options.billingStrategy === 'undefined') {
                console.warn(SpartanAutocomplete.BILLING_NOT_SET_WARNING);
            }
            if (typeof options.countries === 'undefined') {
                console.warn(SpartanAutocomplete.COUNTRIES_NOT_SET_WARNING);
            }
            if (typeof options.letterBuffer === 'undefined') {
                console.warn(SpartanAutocomplete.LETTER_BUTTER_NOT_SET_WARNING);
            }
            if (typeof options.location === 'undefined') {
                console.warn(SpartanAutocomplete.LOCATION_NOT_SET_WARNING);
            }
            if (typeof options.timeBufferMilliseconds === 'undefined') {
                console.warn(SpartanAutocomplete.TIME_BUFFER_NOT_SET_WARNING);
            }
            if (typeof options.type === 'undefined') {
                console.warn(SpartanAutocomplete.TYPE_NOT_SET_WARNING);
            }
        };
        SpartanAutocomplete.prototype.validateOptions = function (options) {
            var b = options.billingStrategy;
            if (b !== 'request-geocode' && b !== 'session-geocode' && b !== 'session-only') {
                throw new Error(SpartanAutocomplete.BILLING_INVALID_ERROR);
            }
            var c = options.countries;
            if (c !== null) {
                if (!Array.isArray(c) || c.length < 1 || c.length > 5) {
                    throw new Error(SpartanAutocomplete.COUNTRIES_INVALID_ERROR);
                }
                else {
                    c.forEach(function (countryCode) {
                        if (!VALID_COUNTRY_CODES[countryCode.toUpperCase()]) {
                            throw new Error(SpartanAutocomplete.COUNTRIES_INVALID_ERROR);
                        }
                    });
                }
            }
            var l = options.location;
            if (l !== null) {
                if (!l.coordinates) {
                    throw new Error(SpartanAutocomplete.LOCATION_INVALID_ERROR);
                }
                var latValid = l.coordinates.lat <= 90 && l.coordinates.lat >= -90;
                var lngValid = l.coordinates.lng <= 180 && l.coordinates.lng >= -180;
                var radiusValid = !isNaN(l.radius) && l.radius > 100 && l.radius < 20000000;
                if (!latValid || !lngValid || !radiusValid) {
                    throw new Error(SpartanAutocomplete.LOCATION_INVALID_ERROR);
                }
            }
            var t = options.type;
            if (t !== 'cities' &&
                t !== 'geocode' &&
                t !== 'address' &&
                t !== 'all' &&
                t !== 'establishment' &&
                t !== 'regions') {
                throw new Error(SpartanAutocomplete.TYPE_INVALID_ERROR);
            }
            var lb = options.letterBuffer;
            if (!(lb >= 0 && lb <= 32)) {
                throw new Error(SpartanAutocomplete.LETTER_BUFFER_INVALID_ERROR);
            }
            var tb = options.timeBufferMilliseconds;
            if (!(tb >= 0 && tb <= 10000)) {
                throw new Error(SpartanAutocomplete.TIME_BUFFER_INVALID_ERROR);
            }
        };
        SpartanAutocomplete.prototype.onBlur = function () {
            this.focused = false;
            this.removePredictions();
        };
        /* Get place using all basic fields by default */
        SpartanAutocomplete.prototype.getPlace = function (fields) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    if (!fields) {
                        fields = BASIC_PLACE_DETAILS_FIELDS;
                    }
                    else if (this.options.billingStrategy !== 'session-only') {
                        throw new Error(SpartanAutocomplete.CANNOT_SPECIFY_FIELDS_ERROR);
                    }
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var getDetailsCallback = function (result) {
                                /* Session is closed so we need a new token to do any further requests */
                                _this.token = new google.maps.places.AutocompleteSessionToken();
                                _this.tokenInUse = _this.options.billingStrategy === 'session-only';
                                if (result.geometry) {
                                    resolve(result);
                                }
                                else {
                                    reject(new Error(SpartanAutocomplete.GETTING_PLACE_ERROR));
                                }
                            };
                            /* If address string is given and we haven't started a session, use a geocode */
                            if (!_this.tokenInUse && _this.inputElement.value) {
                                /* If we're using per-request billing and have selected a prediction, use the place ID */
                                if (_this.placeId) {
                                    _this.geocoder.geocode({ placeId: _this.placeId }, function (results) {
                                        if (results && results.length) {
                                            resolve(results[0]);
                                        }
                                        else {
                                            reject(new Error(SpartanAutocomplete.NO_GEOCODE_RESULTS_ERROR));
                                        }
                                    });
                                    /* Otherwise, if we only have the string the user entered, use that */
                                }
                                else {
                                    _this.geocoder.geocode({ address: _this.inputElement.value }, function (results) {
                                        if (results && results.length) {
                                            resolve(results[0]);
                                        }
                                        else {
                                            reject(new Error(SpartanAutocomplete.NO_GEOCODE_RESULTS_ERROR));
                                        }
                                    });
                                }
                                /* If a session has been started and we have a placeId from it, just run a get details */
                            }
                            else if (_this.tokenInUse && _this.placeId) {
                                /* Complete session with included details request */
                                _this.placesService.getDetails({
                                    fields: fields,
                                    sessionToken: _this.token,
                                    placeId: _this.placeId
                                }, getDetailsCallback);
                                /* If a session has started, but no place was selected, use the session to get a placeId and then
                                 fetch the details */
                            }
                            else if (_this.tokenInUse && _this.inputElement.value) {
                                _this.autocompleteService.getPlacePredictions(_this.buildAutoCompleteRequest(_this.inputElement.value), function (list) {
                                    /* Complete session with included details request */
                                    _this.placesService.getDetails({
                                        fields: fields,
                                        sessionToken: _this.token,
                                        placeId: list[0].place_id
                                    }, getDetailsCallback);
                                });
                            }
                            else {
                                reject(new Error(SpartanAutocomplete.NO_INFORMATION_ERROR));
                            }
                        })];
                });
            });
        };
        SpartanAutocomplete.prototype.buildAutoCompleteRequest = function (input) {
            var request = {
                input: input
            };
            if (this.options.billingStrategy !== 'request-geocode') {
                request.sessionToken = this.token;
            }
            if (this.options.countries) {
                request.componentRestrictions = {
                    country: this.options.countries
                };
            }
            if (this.options.location) {
                request.location = new google.maps.LatLng(this.options.location.coordinates);
                request.radius = this.options.location.radius;
            }
            if (this.options.type !== 'all') {
                request.types = [this.options.type];
            }
            return request;
        };
        SpartanAutocomplete.prototype.onInput = function (event) {
            var _this = this;
            /* Get contents */
            var inputEl = event.srcElement;
            var text = inputEl.value;
            if (text && text.length) {
                /* Clear any pending timeout (for buffering) */
                clearTimeout(this.timeout);
                /* Clear the selected prediction as it is no longer definitely applicable */
                this.placeId = null;
                this.focused = true;
                // this.showFauxList();
                /* Set timeout (for buffering) */
                this.timeout = setTimeout(function () {
                    /* Only execute if we still have focus */
                    if (_this.focused) {
                        if (!_this.options.letterBuffer || text.length >= _this.options.letterBuffer) {
                            _this.autocompleteService.getPlacePredictions(_this.buildAutoCompleteRequest(text), function (list) {
                                /* Only execute if we still have focus */
                                if (list && _this.focused) {
                                    _this.buildList(list);
                                    _this.showList();
                                }
                                else if (list == null) {
                                    setTimeout(function () { return _this.removePredictions(); }, 300);
                                }
                            });
                            /* Mark token as used if sessions are allowed */
                            _this.tokenInUse = _this.options.billingStrategy !== 'request-geocode';
                        }
                        else {
                            setTimeout(function () { return _this.removePredictions(); }, 300);
                        }
                    }
                }, this.options.timeBufferMilliseconds);
            }
            else {
                this.removePredictions();
            }
        };
        SpartanAutocomplete.prototype.removePredictions = function () {
            try {
                /* Clear autocomplete if there's nothing useful to display */
                this.inputElement.parentElement.removeChild(this.predictionsElement);
            }
            catch (e) {
                /* Probably already removed; swallow it. */
            }
        };
        SpartanAutocomplete.prototype.showFauxList = function () {
            this.predictionsElement.innerHTML = '';
            for (var i = 0; i < 4; i++) {
                var li = document.createElement('li');
                li.style.listStyleType = 'none';
                li.style.margin = '0 6px';
                li.style.color = 'lightgray';
                li.style.fontWeight = 'bold';
                li.style.fontSize = '28px';
                li.style.border = '2px solid lightgray';
                li.style.borderWidth = '0 0 2px 0';
                var content = '';
                for (var i_1 = 22 + Math.round(Math.random() * 24); i_1 > 0; i_1--) {
                    content += Math.random() > 0.15 ? '-' : ' ';
                }
                li.appendChild(document.createTextNode(content));
                this.predictionsElement.appendChild(li);
            }
            this.showList();
        };
        SpartanAutocomplete.prototype.buildList = function (list) {
            var _this = this;
            this.predictionsElement.innerHTML = '';
            var _loop_1 = function () {
                var li = document.createElement('li');
                this_1.styleListItemElement(li);
                var prediction = list[i];
                li.appendChild(document.createTextNode(list[i].description));
                li.onmousedown = function () {
                    _this.onSelectItem(prediction);
                };
                this_1.predictionsElement.appendChild(li);
            };
            var this_1 = this;
            for (var i = 0; i < list.length; i++) {
                _loop_1();
            }
            var poweredByGoogleEl = document.createElement('li');
            poweredByGoogleEl.style.padding = '6px';
            var poweredByGoogleImage = document.createElement('img');
            poweredByGoogleImage.src = 'data:image/png;base64, ' + POWERED_BY_GOOGLE_IMAGE;
            poweredByGoogleEl.appendChild(poweredByGoogleImage);
            this.predictionsElement.appendChild(poweredByGoogleEl);
        };
        SpartanAutocomplete.prototype.styleListElement = function (listElement) {
            listElement.style.position = 'absolute';
            listElement.style.color = '#424242';
            listElement.style.border = '1px solid #a6a6a6';
            listElement.style.borderRadius = '3px';
            listElement.style.background = 'white';
            listElement.style.padding = '0';
            listElement.style.margin = '0';
            listElement.style.fontSize = '1em';
            listElement.style.maxWidth = '100%';
        };
        SpartanAutocomplete.prototype.styleListItemElement = function (listItemElement) {
            listItemElement.style.padding = '6px';
            listItemElement.style.listStyleType = 'none';
            listItemElement.style.margin = '0';
            listItemElement.style.cursor = 'pointer';
            listItemElement.style.textOverflow = 'ellipsis';
            listItemElement.style.whiteSpace = 'nowrap';
            listItemElement.style.overflow = 'hidden';
            listItemElement.onmouseenter = function () {
                listItemElement.style.background = '#f2f2f2';
            };
            listItemElement.onmouseout = function () {
                listItemElement.style.background = 'transparent';
            };
        };
        SpartanAutocomplete.prototype.onSelectItem = function (prediction) {
            var text = prediction.description;
            if (this.options.selectionFillFormat === 'main-text') {
                text = prediction.structured_formatting.main_text;
            }
            this.fillInputValue(text, prediction.place_id);
            if (this.predictionSelectedListener) {
                this.predictionSelectedListener(prediction);
            }
        };
        SpartanAutocomplete.prototype.showList = function () {
            var location = {
                x: this.inputElement.offsetLeft,
                y: this.inputElement.offsetTop + this.inputElement.offsetHeight
            };
            this.predictionsElement.style.left = location.x + 'px';
            this.predictionsElement.style.top = location.y + 'px';
            this.inputElement.parentElement.appendChild(this.predictionsElement);
        };
        /* Generate error messages */
        SpartanAutocomplete.ELEMENT_INVALID_ERROR = 'Provided input element is not valid!';
        SpartanAutocomplete.CANNOT_SPECIFY_FIELDS_ERROR = 'Cannot specify fields except when using session-only billing strategy!';
        SpartanAutocomplete.GETTING_PLACE_ERROR = 'Error getting place details by place ID';
        SpartanAutocomplete.NO_INFORMATION_ERROR = 'No information available with which to get place!';
        SpartanAutocomplete.NO_GEOCODE_RESULTS_ERROR = 'No place results returned from geocoder';
        /* Option validation errors */
        SpartanAutocomplete.COUNTRIES_INVALID_ERROR = "Countries option is invalid! Please use an array of (up to 5) two-digit country codes (ISO 3166-1 Alpha-2), e.g. [ 'us', 'ca', 'gb' ]";
        SpartanAutocomplete.LOCATION_INVALID_ERROR = 'Location option is invalid! Please use coordinates as lat/lng literal, along with radius in meters, e.g. { coordinates: { lat: 34, lng: -124 }, radius: 5000 }';
        SpartanAutocomplete.TYPE_INVALID_ERROR = "Type option is invalid! Please use one of 'geocode', 'address', 'establishment', 'regions', 'cities', 'all'";
        SpartanAutocomplete.BILLING_INVALID_ERROR = "Billing strategy invalid! Please use one of 'session-only', 'session-geocode', 'request-geocode'";
        SpartanAutocomplete.LETTER_BUFFER_INVALID_ERROR = 'Number buffer invalid! Please use a number betwen 0 and 32.';
        SpartanAutocomplete.TIME_BUFFER_INVALID_ERROR = 'Time buffer invalid! Please use a number from 0 to 10,000';
        /* Missing option warnings */
        SpartanAutocomplete.COUNTRIES_NOT_SET_WARNING = "Spartan Autocomplete: countries option not set! You can set up to five targeted using two-digit country codes, e.g. [ 'us', 'ca', 'gb' ]. To remove this warning, set countries to null.";
        SpartanAutocomplete.LOCATION_NOT_SET_WARNING = 'Spartan Autocomplete: location option not set! You can set location as coordinates and radius, e.g. { coordinates: { lat: 34, lng: -124 }, radius: 5000 }. To remove this warning, set location to null.';
        SpartanAutocomplete.TYPE_NOT_SET_WARNING = "Spartan Autocomplete: type option not set! You can set the target types 'geocode', 'address', 'establishment', 'regions', 'cities' or 'all'. To remove this warning, set type ('geocode' is default).";
        SpartanAutocomplete.BILLING_NOT_SET_WARNING = "Spartan Autocomplete: billingStrategy not set! You can set to 'session-geocode', 'session-only', or 'request-geocode'. To remove this warning, set billingStrategy ('session-geocode' is default).";
        SpartanAutocomplete.LETTER_BUTTER_NOT_SET_WARNING = 'Spartan Autocomplete: letterBuffer not set! You can set to a number from 0 to 32. This holds off autocomplete predictions until the set number of letters (not numbers) have been typed. To remove this warning, set letterBuffer (2 is default)';
        SpartanAutocomplete.TIME_BUFFER_NOT_SET_WARNING = 'Spartan Autocomplete: timeBufferMilliseconds not set! You can set to a number from 0 to 10,000. This holds off autocomplete predictions until a set pause time. To remove this warning, set timeBufferMilliseconds (0 is default).';
        return SpartanAutocomplete;
    }());
    tsciences.SpartanAutocomplete = SpartanAutocomplete;
})(tsciences || (tsciences = {}));
var VALID_COUNTRY_CODES = {
    AF: 1,
    AX: 1,
    AL: 1,
    DZ: 1,
    AS: 1,
    AD: 1,
    AO: 1,
    AI: 1,
    AQ: 1,
    AG: 1,
    AR: 1,
    AM: 1,
    AW: 1,
    AU: 1,
    AT: 1,
    AZ: 1,
    BS: 1,
    BH: 1,
    BD: 1,
    BB: 1,
    BY: 1,
    BE: 1,
    BZ: 1,
    BJ: 1,
    BM: 1,
    BT: 1,
    BO: 1,
    BA: 1,
    BW: 1,
    BV: 1,
    BR: 1,
    IO: 1,
    BN: 1,
    BG: 1,
    BF: 1,
    BI: 1,
    KH: 1,
    CM: 1,
    CA: 1,
    CV: 1,
    KY: 1,
    CF: 1,
    TD: 1,
    CL: 1,
    CN: 1,
    CX: 1,
    CC: 1,
    CO: 1,
    KM: 1,
    CG: 1,
    CD: 1,
    CK: 1,
    CR: 1,
    CI: 1,
    HR: 1,
    CU: 1,
    CY: 1,
    CZ: 1,
    DK: 1,
    DJ: 1,
    DM: 1,
    DO: 1,
    EC: 1,
    EG: 1,
    SV: 1,
    GQ: 1,
    ER: 1,
    EE: 1,
    ET: 1,
    FK: 1,
    FO: 1,
    FJ: 1,
    FI: 1,
    FR: 1,
    GF: 1,
    PF: 1,
    TF: 1,
    GA: 1,
    GM: 1,
    GE: 1,
    DE: 1,
    GH: 1,
    GI: 1,
    GR: 1,
    GL: 1,
    GD: 1,
    GP: 1,
    GU: 1,
    GT: 1,
    GG: 1,
    GN: 1,
    GW: 1,
    GY: 1,
    HT: 1,
    HM: 1,
    VA: 1,
    HN: 1,
    HK: 1,
    HU: 1,
    IS: 1,
    IN: 1,
    ID: 1,
    IR: 1,
    IQ: 1,
    IE: 1,
    IM: 1,
    IL: 1,
    IT: 1,
    JM: 1,
    JP: 1,
    JE: 1,
    JO: 1,
    KZ: 1,
    KE: 1,
    KI: 1,
    KR: 1,
    KW: 1,
    KG: 1,
    LA: 1,
    LV: 1,
    LB: 1,
    LS: 1,
    LR: 1,
    LY: 1,
    LI: 1,
    LT: 1,
    LU: 1,
    MO: 1,
    MK: 1,
    MG: 1,
    MW: 1,
    MY: 1,
    MV: 1,
    ML: 1,
    MT: 1,
    MH: 1,
    MQ: 1,
    MR: 1,
    MU: 1,
    YT: 1,
    MX: 1,
    FM: 1,
    MD: 1,
    MC: 1,
    MN: 1,
    ME: 1,
    MS: 1,
    MA: 1,
    MZ: 1,
    MM: 1,
    NA: 1,
    NR: 1,
    NP: 1,
    NL: 1,
    AN: 1,
    NC: 1,
    NZ: 1,
    NI: 1,
    NE: 1,
    NG: 1,
    NU: 1,
    NF: 1,
    MP: 1,
    NO: 1,
    OM: 1,
    PK: 1,
    PW: 1,
    PS: 1,
    PA: 1,
    PG: 1,
    PY: 1,
    PE: 1,
    PH: 1,
    PN: 1,
    PL: 1,
    PT: 1,
    PR: 1,
    QA: 1,
    RE: 1,
    RO: 1,
    RU: 1,
    RW: 1,
    BL: 1,
    SH: 1,
    KN: 1,
    LC: 1,
    MF: 1,
    PM: 1,
    VC: 1,
    WS: 1,
    SM: 1,
    ST: 1,
    SA: 1,
    SN: 1,
    RS: 1,
    SC: 1,
    SL: 1,
    SG: 1,
    SK: 1,
    SI: 1,
    SB: 1,
    SO: 1,
    ZA: 1,
    GS: 1,
    ES: 1,
    LK: 1,
    SD: 1,
    SR: 1,
    SJ: 1,
    SZ: 1,
    SE: 1,
    CH: 1,
    SY: 1,
    TW: 1,
    TJ: 1,
    TZ: 1,
    TH: 1,
    TL: 1,
    TG: 1,
    TK: 1,
    TO: 1,
    TT: 1,
    TN: 1,
    TR: 1,
    TM: 1,
    TC: 1,
    TV: 1,
    UG: 1,
    UA: 1,
    AE: 1,
    GB: 1,
    US: 1,
    UM: 1,
    UY: 1,
    UZ: 1,
    VU: 1,
    VE: 1,
    VN: 1,
    VG: 1,
    VI: 1,
    WF: 1,
    EH: 1,
    YE: 1,
    ZM: 1,
    ZW: 1
};
var POWERED_BY_GOOGLE_IMAGE = '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';
